import { useEffect, useState } from "react";
import { ButtonDropdown, DropdownToggle } from "reactstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { EmailAllUserTimesheetReportPayloadType, GetTimeSheetReportDataPayloadType } from "../../../commonTypes/timeSheetTypes";
import { formatDate, reverseDate } from "../../../utils/commonFunctions";
import { CommonHeader, EmptyListPage, ErrorSuccessModal, TableHeader, TableLoader } from "../../../components/commons";
import toast, { Toaster } from "react-hot-toast";
import TimeSheetReportHeader from "../../../components/TimeSheetReports/TimeSheetReportHeader";
import { ComplianceCalendarActiveIcon, ComplianceCalendarIcon, EmptyTimeSheetReportList, ListIcon, ListIconActive } from "../../../assets/images";
import { TIMESHEETREPORT_HEADERS } from "../../../constant/timeSheetReportDropDown/timeSheetListConst";
import TimeSheetReportTable from "../../../components/TimeSheetReports/TimeSheetReportTable";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import TimeSheetCalender from "../TimeSheetCalender";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import { emailAllUserTimesheetReportAction, getTimeSheetCalendarReportDataAction, getTimeSheetReportDataAction, resetTimeSheetError, resetTimeSheetMessage, resetTimeSheetReportBillableTotalTime, resetTimeSheetReportListing, resetTimeSheetReportNonBillableTotalTime, resetTimeSheetReportTotalCount, resetTimeSheetReportTotalTime, resetTimeSheetStatusCode, resetTimeSheetSuccess,resetTimeSheetReportCalenderDataList } from "../../../redux/timeSheet";
import { connect } from "react-redux";

type AppProps = {
  fetching: boolean;
  userFetching: boolean;
  token: string | null;
  timeSheetReportDataList: any[];
  timeSheetReportCalenderDataList: any[];
  totalTime: number;
  billableTotalTime: number;
  nonBillableTotalTime: number;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  totalCount: string | number;
  dispatchResetSession: () => void;
  dispatchGetTimeSheetReportDataAction: (
    data: GetTimeSheetReportDataPayloadType
  ) => void;
  dispatchResetTimeSheetReportSuccess: () => void;
  dispatchResetTimeSheetTotalTime: () => void;
  dispatchResetTimeSheetBillableTotalTime: () => void;
  dispatchResetTimeSheetNonBillableTotalTime: () => void;
  dispatchResetTimeSheetReportError: () => void;
  dispatchResetTimeSheetReportMessage: () => void;
  dispatchResetTimeSheetReportStatusCode: () => void;
  dispatchResetTimeSheetReportTotalCount: () => void;
  dispatchResetTimeSheetReportListing: () => void;
  dispatchEmailAllUserTimesheetReportAction: (
    data: EmailAllUserTimesheetReportPayloadType
  ) => void;
  dispatchGetTimeSheetCalendarReportDataAction: (
    data: GetTimeSheetReportDataPayloadType
  ) => void;
  dispatchResetTimeSheetReportCalenderDataList:()=>void
};

const TimeSheetAdminReport = ({
  fetching,
  token,
  error,
  userFetching,
  statusCode,
  success,
  message,
  totalTime,
  billableTotalTime,
  nonBillableTotalTime,
  totalCount,
  dispatchGetTimeSheetReportDataAction,
  dispatchResetSession,
  timeSheetReportDataList,
  timeSheetReportCalenderDataList,
  dispatchResetTimeSheetTotalTime,
  dispatchResetTimeSheetBillableTotalTime,
  dispatchResetTimeSheetNonBillableTotalTime,
  dispatchResetTimeSheetReportSuccess,
  dispatchResetTimeSheetReportError,
  dispatchResetTimeSheetReportMessage,
  dispatchResetTimeSheetReportStatusCode,
  dispatchResetTimeSheetReportTotalCount,
  dispatchResetTimeSheetReportListing,
  dispatchEmailAllUserTimesheetReportAction,
  dispatchGetTimeSheetCalendarReportDataAction,
  dispatchResetTimeSheetReportCalenderDataList
}: AppProps) => {
  const [data, setData] = useState<any>([]);
  const [calenderData, setCalenderData] = useState<any>([]);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState(20);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [activityCode, setActivityCode] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<string>("");
  const [currentStartDate, setCurrentStartDate] = useState<string>("");
  const [currentEndDate, setCurrentEndDate] = useState<string>("");
  const [type, setType] = useState("");
  const [isToggleTableComponent, setIsToggleTableComponent] = useState(true);
  const [isToggleCalenderComponent, setIsToggleCalenderComponent] = useState(false);

  // Email All User Timesheet Report states
  const [emailReportStartDate, setEmailReportStartDate] = useState<string>("");
  const [emailReportEndtDate, setEmailReportEndDate] = useState<string>("");
  const [calenderDateGap, setCalenderDateGap] = useState<number | null>(null)

  useEffect(() => {
    dispatchResetTimeSheetReportSuccess();
    dispatchResetTimeSheetReportError();
    dispatchResetTimeSheetReportMessage();
    dispatchResetTimeSheetReportStatusCode();
    dispatchResetTimeSheetReportTotalCount();
    dispatchResetTimeSheetReportListing();
    dispatchResetTimeSheetTotalTime();
    dispatchResetTimeSheetBillableTotalTime();
    dispatchResetTimeSheetNonBillableTotalTime();
    dispatchResetTimeSheetReportCalenderDataList()
  }, []);

  useEffect(() => {
    if (timeSheetReportDataList?.length === 0) {
      setData(timeSheetReportDataList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...timeSheetReportDataList]);
    } else {
      setData(timeSheetReportDataList);
    }
  }, [timeSheetReportDataList]);

  useEffect(() => {
    setCalenderData(timeSheetReportCalenderDataList)
  },[timeSheetReportCalenderDataList])

  useEffect(() => {
    dispatchResetTimeSheetReportTotalCount();
    if (token) {
      if (startDate && endDate) {
        let finalData: any = {
          token,
          limit,
          offset,
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
          userId,
          activityCode,
          type,
        };

        if (offset < +totalCount) {
          dispatchGetTimeSheetReportDataAction(finalData);
        } else if (offset === 0 && totalCount === "") {
          dispatchGetTimeSheetReportDataAction(finalData);
        }
      }
    }
  }, [offset]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (timeSheetReportDataList?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [timeSheetReportDataList]);

  const handleSubmitData = (data: any) => {
    dispatchResetTimeSheetTotalTime();
    dispatchResetTimeSheetNonBillableTotalTime()
    dispatchResetTimeSheetReportCalenderDataList();
    dispatchResetTimeSheetBillableTotalTime();
    setSelectedUser(data?.userBasicDetails?.user?.label);
    setCurrentStartDate(data?.startDate);
    setCurrentEndDate(data?.endDate);
    window.scrollTo(0, 0);
    setData([]);
    if (token) {
      let finalData: any = {
        token,
        userId,
        activityCode,
        type,
        ...data,
      };
      if (offset === 0) {
        dispatchGetTimeSheetReportDataAction(finalData);
        dispatchGetTimeSheetCalendarReportDataAction(finalData);
      } else {
        setOffset(0);
        dispatchGetTimeSheetCalendarReportDataAction(finalData)
      }
    }
  };

  const handleEmailReportStartDate = (date: any) => {
    setEmailReportStartDate(date);
  };

  const handleEmailReportEndDate = (date: any) => {
    setEmailReportEndDate(date);
  };

  // Trigger Email for All User Timesheet Rerport
  const handleEmailAllUserTimesheetReportData = () => {
    if (token && emailReportStartDate && emailReportEndtDate) {
      let finalData: EmailAllUserTimesheetReportPayloadType = {
        start_date: formatDate(emailReportStartDate),
        end_date: formatDate(emailReportEndtDate),
        token,
      };

      dispatchEmailAllUserTimesheetReportAction(finalData);
    }
  };

  const handleToggleIsTableComponent = () => {
    if (isToggleCalenderComponent) {

      setIsToggleTableComponent(!isToggleTableComponent);
      setIsToggleCalenderComponent(false);
    }
  };

  const handleResetEmailEndDate=()=>{
    setEmailReportEndDate("")
  }

  const handleToggleIsCalenderComponent = () => {
    if (isToggleTableComponent) {

      setIsToggleCalenderComponent(!isToggleCalenderComponent);
      setIsToggleTableComponent(false)
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetReportError();
            }}
          />
        );
      }
    }
    if (success === 1 && message === "Timesheet list fetched successfully!") {
      dispatchResetTimeSheetReportMessage();
      dispatchResetTimeSheetReportSuccess();
      dispatchResetTimeSheetReportListing();
    }

    if (success === 1 && message === "Email has been sent successfully!") {
      toast.success(
        "Requested Timesheet Report will be mailed to you in 20-minutes!",
        {
          duration: 3000,
        }
      );
      dispatchResetTimeSheetReportMessage();
      dispatchResetTimeSheetReportSuccess();
    }
    return false;
  };

  return (
    <div>
      <CommonHeader title="Timesheet Admin Report" />
      <div className="new-table-card">
        <div className="row">
          <div className="col-md-12 pl-2 pr-2 mt-4 mb-4">
            <TimeSheetReportHeader
              handleSubmitData={handleSubmitData}
              setSelectedUser={setSelectedUser}
              setCurrentStartDate={setCurrentStartDate}
              setCurrentEndDate={setCurrentEndDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              startDate={startDate}
              endDate={endDate}
              setUserId={setUserId}
              setActivityCode={setActivityCode}
              setType={setType}
              handleResetEmailEndDate={handleResetEmailEndDate}
              emailReportStartDate={emailReportStartDate}
              emailReportEndDate={emailReportEndtDate}
              handleEmailAllUserTimesheetReportData={
                handleEmailAllUserTimesheetReportData
              }
              isTimesheetAdminReport
              handleEmailReportStartDate={handleEmailReportStartDate}
              handleEmailReportEndDate={handleEmailReportEndDate}
            />
          </div>
        </div>
        {!!timeSheetReportDataList?.length && (
          <div
            className="row"
            style={{ display: "flex", alignItems: "center",marginTop:"-22px" }}
          >
            <div style={{marginTop:"0px"}}>
              <span
                className="ml-4"
                style={{ fontWeight: "500", letterSpacing: "0.34px",fontSize:"16px" }}
              >
                {selectedUser}
              </span>{" "}
              <span
                className="ml-4"
                style={{ padding: "26px 1px 0", color: "#7c8db0",fontSize:"14px" }}
              >
                {currentStartDate} To {currentEndDate}
              </span>
            </div>
            <div className="ml-5">
              <div style={{ display: "flex", justifyContent: "space-between", gap: "8%" }}>
                <ButtonDropdown
                  toggle={handleToggleIsTableComponent}
                  className="download-report-btn"
                  style={
                    isToggleTableComponent
                      ? {
                        color: "#dd4433",
                        backgroundColor: "#fff6f5",
                      }
                      : {}
                  }
                >
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-download-invoice">
                        Table View Timesheet Report
                      </Tooltip>
                    }
                  >
                    <DropdownToggle
                      caret
                      outline
                      style={
                        isToggleTableComponent
                          ? {
                            color: "#dd4433",
                            backgroundColor: "#fff6f5",
                            border: "1px solid#dd4433",
                          }
                          : { border: "1px solid#bfcbe1" }
                      }
                    >
                      <img src={isToggleTableComponent ? ListIconActive : ListIcon} alt="list-icon" />
                    </DropdownToggle>
                  </OverlayTrigger>
                </ButtonDropdown>


                <ButtonDropdown
                  toggle={handleToggleIsCalenderComponent}
                  className="download-report-btn"
                  style={
                    isToggleCalenderComponent
                      ? {
                        color: "#dd4433",
                        backgroundColor: "#fff6f5",
                      }
                      : {}
                  }
                >
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-download-invoice">
                        Calendar View Timesheet Report
                      </Tooltip>
                    }
                  >
                    <DropdownToggle
                      caret
                      outline
                      style={
                        isToggleCalenderComponent
                          ? {
                            color: "#dd4433",
                            backgroundColor: "#fff6f5",
                            border: "1px solid#dd4433",
                          }
                          : { border: "1px solid#bfcbe1" }
                      }
                    >
                      <img src={isToggleCalenderComponent ? ComplianceCalendarActiveIcon : ComplianceCalendarIcon} alt="list-icon" />
                    </DropdownToggle>
                  </OverlayTrigger>
                </ButtonDropdown>
              </div>
            </div>
          </div>
        )}
        <div className="col-md-12 mt-4 pb-4 pl-0 pr-0">
          <>
            {fetching && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : timeSheetReportDataList?.length > 0 && isToggleTableComponent ? (
              <div className="jobsType">
                <table className="table thead-light table-bordered">
                  <thead className="text-start sticky-table-header-without-zindex">
                    <tr className="new-table-head" style={{fontSize:"11px"}}>
                      <td colSpan={2}>
                        <strong>Total Hrs : {typeof totalTime === "number" && totalTime
                          ? totalTime.toFixed(2)
                          : 0}</strong>
                      </td>
                      <td colSpan={2}>
                        <strong>Billable Total Hrs : {typeof billableTotalTime === "number" &&
                          billableTotalTime
                          ? billableTotalTime.toFixed(2)
                          : 0}</strong>
                      </td>
                      <td colSpan={2}>
                        <strong>Non Billable Total Hrs : {typeof nonBillableTotalTime === "number" &&
                          nonBillableTotalTime
                          ? nonBillableTotalTime.toFixed(2)
                          : 0}</strong>
                      </td>
                      <td></td>
                    </tr>
                    <TableHeader tableHeader={TIMESHEETREPORT_HEADERS} />
                  </thead>
                  <tbody>
                    <TimeSheetReportTable
                      data={data}
                      tableHeaders={TIMESHEETREPORT_HEADERS}
                    />
                    <div style={{ display: fetching ? "none" : "inline" }}>
                      <ScrollToTop />
                    </div>
                    {fetching && offset > 0 && (
                      <div>{<InfiniteLoader />}</div>
                    )}
                  </tbody>
                </table>
              </div>
            ) : timeSheetReportDataList?.length > 0 && !isToggleTableComponent && isToggleCalenderComponent ? (
              <>
                <TimeSheetCalender data={calenderData} startDate={reverseDate(currentStartDate)} endDate={reverseDate(currentEndDate)} calenderDateGap={calenderDateGap} />
              </>
            ) : (
              <>
                {!fetching && data?.length === 0 && (
                  <EmptyListPage
                    title="No Timesheet List!"
                    imageWidth="30%"
                    image={EmptyTimeSheetReportList}
                    showAddButton={false}
                  />
                )}
              </>
            )}
          </>
        </div>
      </div>

      <Toaster
        toastOptions={{
          style: {
            textAlign: "center",
          },
        }}
      />
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  userFetching: state.auth.fetching,
  totalTime: state.timeSheet.reportTotalTime,
  billableTotalTime: state.timeSheet.reportTotalBillableTime,
  nonBillableTotalTime: state.timeSheet.reportTotalNonBillableTime,
  activityCodeListing: state.masterData.masterDataActivivtyCodeListing,
  timeSheetReportDataList: state.timeSheet.timeSheetReportDataList,
  timeSheetReportCalenderDataList: state.timeSheet.timeSheetReportCalenderDataList,
  totalCount: state.timeSheet.timeSheetReportTotalCount,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetReportSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetReportError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetReportMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetReportStatusCode: () =>
    dispatch(resetTimeSheetStatusCode()),
  dispatchResetTimeSheetReportTotalCount: () =>
    dispatch(resetTimeSheetReportTotalCount()),
  dispatchResetTimeSheetReportListing: () =>
    dispatch(resetTimeSheetReportListing()),
  dispatchGetTimeSheetReportDataAction: (
    data: GetTimeSheetReportDataPayloadType
  ) => dispatch(getTimeSheetReportDataAction(data)),
  dispatchResetTimeSheetTotalTime: () =>
    dispatch(resetTimeSheetReportTotalTime()),
  dispatchResetTimeSheetBillableTotalTime: () =>
    dispatch(resetTimeSheetReportBillableTotalTime()),
  dispatchResetTimeSheetNonBillableTotalTime: () =>
    dispatch(resetTimeSheetReportNonBillableTotalTime()),
  dispatchEmailAllUserTimesheetReportAction: (
    data: EmailAllUserTimesheetReportPayloadType
  ) => dispatch(emailAllUserTimesheetReportAction(data)),
  dispatchGetTimeSheetCalendarReportDataAction: (data: GetTimeSheetReportDataPayloadType) => dispatch(getTimeSheetCalendarReportDataAction(data)),
  dispatchResetTimeSheetReportCalenderDataList:()=>dispatch(resetTimeSheetReportCalenderDataList())
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeSheetAdminReport);
